import { schema } from "normalizr"

export const librarySchema = new schema.Entity("libraryItems")
